import React from 'react';
import {FileUpload} from '../components/FileInput';
import Attachments from 'routes/visits/components/UnitForm/Attachments';

const Upload = () => (
    <div style={{maxWidth:600,margin:'40px auto'}}>
        <Attachments documentId={'257'} attachments={[
         {
            "id":47,
            "filename":"dummy.jpeg"
         },
         {
            "id":48,
            "filename":"dummy.pdf"
         }
      ]}/>
    </div>
);

export default Upload;